@if (content$ | async; as content) {
  <div class="blockquote">
    <a data-cy="blockQuoteHeading" c11n-link variant="primary-independent" class="blockquote__heading"
      aria-describedby="phone-number" [href]="content.blockquoteHeading.link">
      <span [innerHTML]="content.blockquoteHeading.label"></span>
    </a>
    <p data-cy="blockQuoteText" class="blockquote__text" [innerHTML]="content.blockquoteText"></p>
  </div>
  <span hidden id="phone-number">phone number</span>
}
